import { css } from 'styled-components'
import { themeGet } from '@style'

const styles = css`
  display: inline-block;
  max-width: 300px;
  box-sizing: border-box;
  padding: 12px 26px;
  text-decoration: none;
  cursor: pointer;
  outline: 0;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.04em;
  position: relative;
  color: ${(props) => (props.primary ? themeGet('colors.saddleBrown')(props) : '#2F80ED')};
  background-color: ${(props) => (props.primary ? themeGet('colors.peach')(props) : '#fff')};
  border: 0 solid transparent;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 999px;
  white-space: nowrap;
  transition: all 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: rgba(50, 50, 93, 0.05) 0 18px 18px,
      rgba(0, 0, 0, 0.07) 0 9px 17px;

    &::after {
      background: rgba(255, 255, 255, 0.5);
    }

    svg {
      fill: #fff;
    }
  }

  &:active {
    transform: translateY(0);

    &::after {
      background: rgba(255, 255, 255, 0.48);
    }

    svg {
      fill: #fafafa;
    }
  }
`

export default styles
